import { Link } from "react-router-dom";
import { Kicker } from "@/components/ui/kicker";
import {
  RunStatusBadge,
  walkthroughStatusToRunStatus,
} from "@/components/walkthrough-badges";

export interface PersonaWalkthroughItem {
  id: string;
  scenarioId: string;
  scenarioName: string | null;
  mode: string;
  status: string;
  completedAt: string | null;
}

interface PersonaWalkthroughsSectionProps {
  walkthroughs: PersonaWalkthroughItem[];
  projectId: string;
  firstName: string;
  runNumbers: Map<string, number>;
}

export function PersonaWalkthroughsSection({
  walkthroughs,
  projectId,
  firstName,
  runNumbers,
}: PersonaWalkthroughsSectionProps) {
  return (
    <section className="space-y-4">
      <div className="flex items-baseline gap-3">
        <Kicker as="h2">Walkthroughs</Kicker>
        <span className="text-sm text-muted-foreground">
          Runs where {firstName} evaluated the product
        </span>
      </div>
      {walkthroughs.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          No walkthroughs run as {firstName} yet.
        </p>
      ) : (
        <div className="rounded-lg border border-border bg-card overflow-hidden divide-y divide-border">
          {walkthroughs.map((wt) => {
            const run = runNumbers.get(wt.id);
            const href = `/projects/${projectId}/walkthroughs/${wt.id}`;
            return (
              <Link
                key={wt.id}
                to={href}
                className="flex items-center gap-4 px-4 py-3 hover:bg-muted/40 transition-colors"
              >
                <div className="min-w-0 flex-1 space-y-0.5">
                  <div className="flex flex-wrap items-baseline gap-x-2">
                    <span className="text-sm font-semibold tracking-tight text-foreground hover:underline">
                      {run && (
                        <span className="text-xs font-semibold text-muted-foreground mr-1.5">
                          Run #{run} ·
                        </span>
                      )}
                      {wt.scenarioName}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      · {wt.mode.replace(/_/g, " ")}
                    </span>
                  </div>
                  <RunStatusBadge
                    status={walkthroughStatusToRunStatus(wt.status)}
                  />
                </div>
                {wt.completedAt && (
                  <time
                    dateTime={new Date(wt.completedAt).toISOString()}
                    className="shrink-0 text-right text-xs tabular-nums text-muted-foreground"
                  >
                    {new Date(wt.completedAt).toLocaleDateString()}
                  </time>
                )}
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
}
